const products = [
  {
    id: "vpn",
    name: "VPN",
    tagline: "Private & Secure Browsing",
    description:
      "A powerful VPN application that encrypts your internet connection, masks your IP address, and shields your personal data from threats. Browse freely with total confidence on any network.",
    features: [
      "Military-grade encryption",
      "Zero-log policy",
      "Automatic kill switch",
      "Global server network",
    ],
    badge: "Privacy",
    imageUrl:
      "https://public.readdy.ai/ai/img_res/4a4a7bd283f6dc0bb61982b2aaf0118b.jpg",
    accent: "bg-[#1A1A1A]",
    textLight: true,
  },
  {
    id: "cleaner",
    name: "Cleaner",
    tagline: "Optimize Your iPhone",
    description:
      "An intelligent cleaner that removes junk files, duplicate photos, and unnecessary cache data, giving your iPhone a significant performance boost and freeing up valuable storage space.",
    features: [
      "Smart junk file removal",
      "Duplicate photo detector",
      "Cache & memory cleaner",
      "Storage analytics",
    ],
    badge: "Performance",
    imageUrl:
      "https://readdy.ai/api/search-image?query=premium%20iPhone%20iOS%20cleaner%20app%20mobile%20application%20UI%20mockup%20on%20warm%20light%20beige%20background%2C%20showing%20storage%20circular%20progress%20chart%20and%20file%20categories%2C%20clean%20light%20theme%20minimalist%20interface%2C%20professional%20product%20photography%2C%20soft%20natural%20lighting%2C%20ultra%20sharp%20high%20resolution&width=500&height=600&seq=cleaner001&orientation=portrait",
    accent: "bg-[#F7F0E8]",
    textLight: false,
  },
];

export default function ProductsSection() {
  return (
    <section id="products" className="py-32 bg-white">
      <div className="max-w-7xl mx-auto px-8 md:px-16">
        {/* Header */}
        <div className="flex flex-col items-center text-center mb-20">
          <span className="text-xs tracking-[0.35em] uppercase text-amber-700 font-semibold mb-4">
            What We Build
          </span>
          <h2 className="text-5xl md:text-6xl font-black text-gray-900 leading-tight mb-6">
            Our<br />
            <span className="text-amber-700">Products</span>
          </h2>
          <div className="w-16 h-0.5 bg-amber-600 mb-6" />
          <p className="text-lg text-gray-500 max-w-xl leading-relaxed">
            Thoughtfully designed iOS applications built to protect your privacy and elevate your device experience.
          </p>
        </div>

        {/* Product cards */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10">
          {products.map((product) => (
            <article
              key={product.id}
              className={`rounded-3xl overflow-hidden border border-gray-100 flex flex-col lg:flex-row min-h-[480px] ${product.accent}`}
            >
              {/* Image side */}
              <div className="w-full lg:w-2/5 min-h-[260px] lg:min-h-0 flex-shrink-0">
                <img
                  src={product.imageUrl}
                  alt={`${product.name} iOS application`}
                  className="w-full h-full object-cover object-top"
                />
              </div>

              {/* Content side */}
              <div className="flex flex-col justify-center p-10 flex-1">
                <span
                  className={`inline-block text-xs tracking-[0.3em] uppercase font-semibold mb-4 ${
                    product.textLight ? "text-amber-300/80" : "text-amber-700"
                  }`}
                >
                  {product.badge}
                </span>
                <h3
                  className={`text-4xl font-black mb-2 ${
                    product.textLight ? "text-white" : "text-gray-900"
                  }`}
                >
                  {product.name}
                </h3>
                <p
                  className={`text-sm font-medium mb-5 ${
                    product.textLight ? "text-white/60" : "text-gray-500"
                  }`}
                >
                  {product.tagline}
                </p>
                <p
                  className={`text-sm leading-relaxed mb-8 ${
                    product.textLight ? "text-white/75" : "text-gray-600"
                  }`}
                >
                  {product.description}
                </p>

                <ul className="space-y-3">
                  {product.features.map((f) => (
                    <li key={f} className="flex items-center gap-3">
                      <div
                        className={`w-5 h-5 flex items-center justify-center rounded-full flex-shrink-0 ${
                          product.textLight ? "bg-amber-500/20" : "bg-amber-100"
                        }`}
                      >
                        <i
                          className={`ri-check-line text-xs ${
                            product.textLight ? "text-amber-300" : "text-amber-700"
                          }`}
                        />
                      </div>
                      <span
                        className={`text-sm ${
                          product.textLight ? "text-white/80" : "text-gray-700"
                        }`}
                      >
                        {f}
                      </span>
                    </li>
                  ))}
                </ul>
              </div>
            </article>
          ))}
        </div>

        {/* Bottom banner */}
        <div className="mt-16 rounded-3xl bg-[#1A1A1A] px-12 py-12 flex flex-col md:flex-row items-center justify-between gap-8">
          <div>
            <p className="text-xs tracking-[0.3em] uppercase text-amber-300/70 font-medium mb-2">Available on</p>
            <p className="text-3xl font-black text-white">iOS Platform</p>
          </div>
          <div className="flex items-center gap-3 text-white/60">
            <div className="w-8 h-8 flex items-center justify-center">
              <i className="ri-apple-fill text-3xl text-white" />
            </div>
            <span className="text-lg font-light">Apple iOS</span>
          </div>
          <div className="flex flex-col gap-1 text-right">
            <p className="text-sm text-white/50">Designed for</p>
            <p className="text-xl font-bold text-amber-300">iPhone &amp; iPad</p>
          </div>
        </div>
      </div>
    </section>
  );
}
